import Vue from 'vue'
import VueRouter from 'vue-router'

// 导入登录页面组件
import AdminLogin from '../views/admin/Login.vue'
import MerchantLogin from '../views/merchant/Login.vue'
import CustomerLogin from '../views/customer/Login.vue'
import CustomerRegister from '../views/customer/Register.vue'
import CustomerLayout from '../views/customer/Layout.vue'

// 导入管理后台组件
import AdminLayout from '../views/admin/Layout.vue'
import AdminDashboard from '../views/admin/Dashboard.vue'
// 统一使用通用订单组件
import OrderList from '../views/admin/orders/OrderList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/admin/login'
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { title: '管理后台登录' }
  },
  {
    path: '/merchant/login',
    name: 'MerchantLogin',
    component: MerchantLogin,
    meta: { title: '商家端登录' }
  },
  {
    path: '/customer/login',
    name: 'CustomerLogin',
    component: CustomerLogin,
    meta: { title: '客户端登录' }
  },
  {
    path: '/customer/register',
    name: 'CustomerRegister',
    component: CustomerRegister,
    meta: { title: '客户端注册' }
  },
  // 客户端路由
  {
    path: '/customer',
    component: CustomerLayout,
    redirect: '/customer/orders/all',
    children: [
      {
        path: 'orders/all',
        name: 'CustomerAllOrders',
        component: () => import('../views/customer/orders/OrderList.vue'),
        meta: { title: '订单管理', subTitle: '所有订单', icon: 'el-icon-s-order' }
      },
      {
        path: 'orders/not-shipped',
        name: 'CustomerNotShippedOrders',
        component: () => import('../views/customer/orders/OrderList.vue'),
        meta: { title: '订单管理', subTitle: '未邮寄订单', icon: 'el-icon-document' }
      },
      {
        path: 'orders/in-transit',
        name: 'CustomerInTransitOrders',
        component: () => import('../views/customer/orders/OrderList.vue'),
        meta: { title: '订单管理', subTitle: '在途订单', icon: 'el-icon-truck' }
      },
      {
        path: 'orders/testing',
        name: 'CustomerTestingOrders',
        component: () => import('../views/customer/orders/OrderList.vue'),
        meta: { title: '订单管理', subTitle: '测试中订单', icon: 'el-icon-loading' }
      },
      {
        path: 'orders/tested',
        name: 'CustomerTestedOrders',
        component: () => import('../views/customer/orders/OrderList.vue'),
        meta: { title: '订单管理', subTitle: '已测试订单', icon: 'el-icon-check' }
      },
      {
        path: 'orders/completed',
        name: 'CustomerCompletedOrders',
        component: () => import('../views/customer/orders/OrderList.vue'),
        meta: { title: '订单管理', subTitle: '已完成订单', icon: 'el-icon-circle-check' }
      },
      {
        path: 'orders/expiring',
        name: 'CustomerOrdersExpiring',
        component: () => import('@/views/customer/orders/OrderList'),
        meta: { 
          title: '订单管理',
          subTitle: '即将/已超期订单',
          icon: 'el-icon-alarm-clock'
        }
      },
      {
        path: 'orders/return',
        name: 'CustomerOrdersReturn',
        component: () => import('@/views/customer/orders/OrderList'),
        meta: { 
          title: '订单管理',
          subTitle: '回寄/转寄订单',
          icon: 'el-icon-back'
        }
      },
      {
        path: 'orders/dispute',
        name: 'CustomerDisputeOrders',
        component: () => import('../views/customer/orders/OrderList.vue'),
        meta: { title: '订单管理', subTitle: '争议/复测订单', icon: 'el-icon-warning' }
      },
      {
        path: 'orders/detail/:id',
        name: 'CustomerOrderDetail',
        component: () => import('@/views/admin/orders/OrderDetail.vue'),
        meta: { 
          title: '订单详情',
          icon: 'el-icon-document'
        }
      },
      {
        path: 'orders/ship/:id',
        name: 'CustomerOrderShip',
        component: () => import('@/views/admin/orders/ShipOrder'),
        meta: { 
          title: '邮寄样品',
          icon: 'el-icon-truck'
        }
      },
      {
        path: 'orders/dispute/:id',
        name: 'CustomerOrderDispute',
        component: () => import('@/views/admin/orders/DisputeSubmit'),
        meta: { 
          title: '提出争议/复测',
          icon: 'el-icon-warning'
        }
      },
      {
        path: 'orders/report/:id',
        name: 'CustomerOrderReport',
        component: () => import('@/views/admin/orders/OrderDetail.vue'),
        meta: { 
          title: '订单报告',
          icon: 'el-icon-document'
        }
      },
      {
        path: 'orders/return/:id',
        name: 'CustomerOrderReturn',
        component: () => import('@/views/admin/orders/ReturnSample.vue'),
        meta: { 
          title: '申请回寄',
          icon: 'el-icon-back'
        }
      },
      {
        path: 'orders/forward/:id',
        name: 'CustomerOrderForward',
        component: () => import('@/views/admin/orders/ForwardSample.vue'),
        meta: { 
          title: '申请转寄',
          icon: 'el-icon-right'
        }
      },
      {
        path: 'orders/management/:id',
        name: 'CustomerOrderManagement',
        component: () => import('@/views/admin/orders/OrderManagement.vue'),
        meta: { 
          title: '订单管理',
          icon: 'el-icon-s-order'
        }
      },
      {
        path: 'orders/process-retest/:id',
        name: 'CustomerProcessRetest',
        component: () => import('@/views/admin/orders/status/ProcessRetestForm.vue'),
        meta: { 
          title: '处理复测申请',
          icon: 'el-icon-warning'
        }
      },
      {
        path: 'profile',
        name: 'CustomerProfile',
        component: () => import('../views/customer/Profile.vue'),
        meta: { title: '个人信息', icon: 'el-icon-user' }
      },
      {
        path: 'change-password',
        name: 'CustomerChangePassword',
        component: () => import('../views/customer/ChangePassword.vue'),
        meta: { title: '修改密码', icon: 'el-icon-lock' }
      }
    ]
  },
  // 管理后台路由
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: AdminDashboard,
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      // 订单管理相关路由
      {
        path: 'orders',
        name: 'OrderManagement',
        component: () => import('../views/admin/orders/OrderManagement.vue'),
        meta: { title: '订单管理', icon: 'el-icon-s-order' },
        children: [
          {
            path: 'create',
            name: 'AdminCreateOrder',
            component: () => import('../views/admin/orders/CreateOrder.vue'),
            meta: { title: '订单管理', subTitle: '创建订单', icon: 'el-icon-plus' }
          }
        ]
      },
      {
        path: 'orders/create-forward',
        name: 'AdminCreateForwardOrder',
        component: () => import('../views/admin/orders/CreateOrder.vue'),
        props: { type: 'forward' },
        meta: { title: '订单管理', subTitle: '创建转寄订单', icon: 'el-icon-plus' }
      },
      {
        path: 'orders/all',
        name: 'AdminAllOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '所有订单', icon: 'el-icon-s-order' }
      },
      {
        path: 'orders/detail/:id',
        name: 'OrderDetail',
        component: () => import('@/views/admin/orders/OrderDetail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: 'orders/edit/:id',
        name: 'EditOrder',
        component: () => import('@/views/admin/orders/EditOrder.vue'),
        meta: { title: '编辑订单' }
      },
      {
        path: 'orders/edit-merchant/:id',
        name: 'EditMerchantInfo',
        component: () => import('@/views/admin/orders/EditMerchantInfo.vue'),
        meta: { title: '编辑商家和物流信息' }
      },
      {
        path: 'orders/ship/:id',
        name: 'ShipOrder',
        component: () => import('@/views/admin/orders/ShipOrder.vue'),
        meta: { title: '邮寄样品' }
      },
      {
        path: 'orders/management/:id',
        name: 'OrderManagementDetail',
        component: () => import('@/views/admin/orders/OrderManagement.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'orders/return/:id',
        name: 'ReturnSample',
        component: () => import('@/views/admin/orders/ReturnSample.vue'),
        meta: { title: '回寄样品' }
      },
      {
        path: 'orders/transfer/:id',
        name: 'TransferSample',
        component: () => import('@/views/admin/orders/TransferSample.vue'),
        meta: { title: '转寄样品' }
      },
      {
        path: 'orders/not-shipped',
        name: 'AdminNotShippedOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '未邮寄订单', icon: 'el-icon-document' }
      },
      {
        path: 'orders/in-transit',
        name: 'AdminInTransitOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '在途订单', icon: 'el-icon-truck' }
      },
      {
        path: 'orders/testing',
        name: 'AdminTestingOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '测试中订单', icon: 'el-icon-loading' }
      },
      {
        path: 'orders/tested',
        name: 'AdminTestedOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '已测试订单', icon: 'el-icon-check' }
      },
      {
        path: 'orders/completed',
        name: 'AdminCompletedOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '已完成订单', icon: 'el-icon-circle-check' }
      },
      {
        path: 'orders/expiring',
        name: 'AdminExpiringOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '即将/已超期订单', icon: 'el-icon-alarm-clock' }
      },
      {
        path: 'orders/dispute',
        name: 'AdminDisputeOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '争议/复测订单', icon: 'el-icon-warning' }
      },
      {
        path: 'orders/dispute/submit/:id',
        name: 'AdminDisputeSubmit',
        component: () => import('@/components/orders/DisputeSubmit.vue'),
        props: { role: 'admin' },
        meta: { title: '提交争议/复测申请' }
      },
      {
        path: 'orders/process-retest/:id',
        name: 'AdminProcessRetest',
        component: () => import('@/views/admin/orders/status/ProcessRetestForm.vue'),
        meta: { title: '处理复测申请' }
      },
      {
        path: 'orders/unsettled',
        name: 'AdminUnsettledOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '未结算订单', icon: 'el-icon-money' }
      },
      {
        path: 'orders/return',
        name: 'AdminReturnOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '回寄/转寄订单', icon: 'el-icon-back' }
      },
      {
        path: 'orders/status/upload-result/:id',
        name: 'OrderUploadResult',
        component: () => import('@/views/admin/orders/status/UploadTestResult'),
        meta: { title: '上传测试结果', roles: ['admin', 'super'] }
      },
      {
        path: 'orders/reports/upload/:id',
        name: 'UploadReports',
        component: () => import('@/views/admin/orders/reports/UploadReports'),
        meta: { title: '上传测试报告和清单', roles: ['admin', 'super'] }
      },
      {
        path: 'orders/pending',
        name: 'AdminPendingOrders',
        component: () => import('../views/admin/orders/PendingOrders.vue'),
        meta: { title: '订单管理', subTitle: '待处理订单', icon: 'el-icon-bell', adminOnly: true }
      },
      {
        path: 'orders/compare/:id',
        name: 'CompareTestResult',
        component: () => import('@/views/admin/orders/CompareTestResult.vue'),
        meta: {
          title: '对比测试结果',
          requiresAuth: true
        }
      },
      // 其他主菜单路由
      {
        path: 'devices',
        name: 'AdminDevices',
        component: () => import('../views/admin/device/Devices.vue'),
        meta: { title: '仪器信息', icon: 'el-icon-cpu' }
      },
      {
        path: 'merchants',
        name: 'AdminMerchants',
        component: () => import('../views/admin/merchant/Merchants.vue'),
        meta: { title: '商家管理', icon: 'el-icon-s-shop' }
      },
      {
        path: 'customers',
        name: 'AdminCustomers',
        component: () => import('../views/admin/customer/Customers.vue'),
        meta: { title: '客户管理', icon: 'el-icon-user' }
      },
      {
        path: 'logistics',
        name: 'AdminLogistics',
        component: () => import('../views/admin/logistics/Logistics.vue'),
        meta: {
          requiresAuth: true,
          allowedRoles: ['ADMIN'],
          title: '物流管理',
          subTitle: '物流公司'
        }
      },
      {
        path: 'change-password',
        name: 'AdminChangePassword',
        component: () => import('../views/admin/ChangePassword.vue'),
        meta: { title: '修改密码', icon: 'el-icon-lock' }
      },
      {
        path: '/admin/system/config',
        name: 'SysConfig',
        component: () => import('@/views/admin/system/SysConfig.vue'),
        meta: {
          requiresAuth: true,
          allowedRoles: ['ADMIN'],
          title: '系统管理',
          subTitle: '系统配置'
        }
      },
      {
        path: 'register-code',
        name: 'AdminRegisterCode',
        component: () => import('../views/admin/system/RegisterCodes.vue'),
        meta: { 
          title: '系统管理', 
          subTitle: '注册码管理', 
          icon: 'el-icon-key',
          adminOnly: true 
        }
      },
      {
        path: 'agreement',
        name: 'AdminAgreement',
        component: () => import('../views/admin/system/AgreementManage.vue'),
        meta: { 
          title: '系统管理', 
          subTitle: '客户协议管理', 
          icon: 'el-icon-document',
          adminOnly: true 
        }
      },
      // 结算管理相关路由
      {
        path: 'settlement/monthly',
        name: 'AdminMonthlySettlement',
        component: () => import('@/views/admin/settlement/MonthlySettlement.vue'),
        meta: { 
          title: '月结算表单', 
          icon: 'el-icon-s-finance',
          adminOnly: true 
        }
      }
    ]
  },
  // 商家端路由
  {
    path: '/merchant',
    component: () => import('../views/merchant/Layout.vue'),
    redirect: '/merchant/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'MerchantDashboard',
        component: () => import('../views/merchant/Dashboard.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' }
      },
      {
        path: 'orders/all',
        name: 'MerchantAllOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '所有订单', icon: 'el-icon-s-order' }
      },
      {
        path: 'orders/not-shipped',
        name: 'MerchantNotShippedOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '未邮寄订单', icon: 'el-icon-document' }
      },
      {
        path: 'orders/in-transit',
        name: 'MerchantInTransitOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '在途订单', icon: 'el-icon-truck' }
      },
      {
        path: 'orders/testing',
        name: 'MerchantTestingOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '测试中订单', icon: 'el-icon-loading' }
      },
      {
        path: 'orders/tested',
        name: 'MerchantTestedOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '已测试订单', icon: 'el-icon-check' }
      },
      {
        path: 'orders/completed',
        name: 'MerchantCompletedOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '已完成订单', icon: 'el-icon-circle-check' }
      },
      {
        path: 'orders/expiring',
        name: 'MerchantExpiringOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '即将/已超期订单', icon: 'el-icon-alarm-clock' }
      },
      {
        path: 'orders/unsettled',
        name: 'MerchantUnsettledOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '未结算订单', icon: 'el-icon-money' }
      },
      {
        path: 'orders/return',
        name: 'MerchantReturnOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '回寄/转寄订单', icon: 'el-icon-back' }
      },
      {
        path: 'orders/dispute',
        name: 'MerchantDisputeOrders',
        component: OrderList,
        meta: { title: '订单管理', subTitle: '争议/复测订单', icon: 'el-icon-warning' }
      },
      {
        path: 'orders/dispute/submit/:id',
        name: 'MerchantDisputeSubmit',
        component: () => import('@/components/orders/DisputeSubmit.vue'),
        props: { role: 'merchant' },
        meta: { title: '提交争议/复测申请' }
      },
      {
        path: 'orders/detail/:id',
        name: 'MerchantOrderDetail',
        component: () => import('@/views/admin/orders/OrderDetail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: 'orders/management/:id',
        name: 'MerchantOrderManagement',
        component: () => import('@/views/admin/orders/OrderManagement.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'orders/upload-result/:id',
        name: 'MerchantUploadTestResult',
        component: () => import('@/views/admin/orders/status/UploadTestResult.vue'),
        props: { isRetest: false },
        meta: { title: '上传测试结果' }
      },
      {
        path: 'orders/upload-retest/:id',
        name: 'MerchantUploadRetestResult',
        component: () => import('@/views/admin/orders/status/UploadTestResult.vue'),
        props: { isRetest: true },
        meta: { title: '上传复测结果' }
      },
      {
        path: 'orders/process-retest/:id',
        name: 'MerchantProcessRetest',
        component: () => import('@/views/admin/orders/status/ProcessRetestForm.vue'),
        meta: { title: '处理复测申请' }
      },
      {
        path: 'devices',
        name: 'MerchantDevices',
        component: () => import('../views/merchant/device/Devices.vue'),
        meta: { title: '仪器管理', icon: 'el-icon-data-analysis' }
      },
      {
        path: 'profile',
        name: 'MerchantProfile',
        component: () => import('../views/merchant/Profile.vue'),
        meta: { title: '个人信息', icon: 'el-icon-user' }
      },
      {
        path: 'change-password',
        name: 'MerchantChangePassword',
        component: () => import('../views/merchant/ChangePassword.vue'),
        meta: { title: '修改密码', icon: 'el-icon-lock' }
      },
      // 结算管理相关路由
      {
        path: 'settlement/monthly',
        name: 'MerchantMonthlySettlement',
        component: () => import('@/views/merchant/settlement/MonthlySettlement.vue'),
        meta: { title: '月结算表单', icon: 'el-icon-s-finance' }
      },
    ]
  },
  // 默认重定向到首页
  {
    path: '*',
    redirect: '/customer/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 添加全局前置守卫，根据域名跳转到不同的登录页面
router.beforeEach((to, from, next) => {
  // 获取当前域名和环境
  const hostname = window.location.hostname
  const appEnv = window.APP_ENV || ''
  
  console.log('[路由守卫] 当前域名:', hostname, '当前路径:', to.path, '环境:', appEnv, '来源:', from.path)

  // 在任何处理之前先判断 - 如果是www域名访问admin路径，直接重定向到customer路径
  if ((hostname === 'www.sainanecv.com' || hostname === 'sainanecv.com' || 
       hostname === 'www.xiaobangkeyan.com' || hostname === 'xiaobangkeyan.com') && 
      to.path.startsWith('/admin/')) {
    console.log('[路由守卫] www域名访问admin路径，直接重定向到customer登录')
    next('/customer/login')
    return
  }
  
  // 如果是直接访问根路径，根据环境和域名重定向
  if (to.path === '/') {
    // 首先按域名判断 www 和主域名
    if (hostname === 'www.sainanecv.com' || hostname === 'sainanecv.com' ||
        hostname === 'www.xiaobangkeyan.com' || hostname === 'xiaobangkeyan.com') {
      console.log('[路由守卫] 检测到www域名或主域名访问根路径，跳转到客户登录')
      next('/customer/login')
      return
    }
    
    // 然后根据环境变量判断
    if (appEnv === 'admin') {
      console.log('[路由守卫] 检测到管理端环境，跳转到管理员登录')
      next('/admin/login')
      return
    } else if (appEnv === 'customer') {
      console.log('[路由守卫] 检测到客户端环境，跳转到客户登录')
      next('/customer/login')
      return
    } else if (appEnv === 'merchant') {
      console.log('[路由守卫] 检测到商家端环境，跳转到商家登录')
      next('/merchant/login')
      return
    }
    
    // 最后按其他域名判断
    if (hostname === 'admin.sainanecv.com' || hostname === 'admin.xiaobangkeyan.com') {
      console.log('[路由守卫] 检测到管理端域名，跳转到管理员登录')
      next('/admin/login')
      return
    } else if (hostname === 'customer.sainanecv.com' || hostname === 'customer.xiaobangkeyan.com') {
      console.log('[路由守卫] 检测到客户端域名，跳转到客户登录')
      next('/customer/login')
      return
    } else if (hostname === 'merchant.sainanecv.com' || hostname === 'merchant.xiaobangkeyan.com') {
      console.log('[路由守卫] 检测到商家端域名，跳转到商家登录')
      next('/merchant/login')
      return
    } else {
      console.log('[路由守卫] 未识别的域名，默认跳转到客户登录')
      next('/customer/login')
      return
    }
  }

  // 检查环境与路径是否匹配
  if (appEnv === 'admin') {
    // 如果是管理员环境，但访问的不是管理员路径
    if (!to.path.startsWith('/admin') && to.path !== '/') {
      console.log('[路由守卫] 管理员环境访问非管理员路径:', to.path)
      next('/admin/login')
      return
    }
  } else if (appEnv === 'merchant') {
    // 如果是商家环境，但访问的不是商家路径
    if (!to.path.startsWith('/merchant') && to.path !== '/') {
      console.log('[路由守卫] 商家环境访问非商家路径:', to.path)
      next('/merchant/login')
      return
    }
  } else if (appEnv === 'customer') {
    // 如果是客户端环境，但访问的不是客户端路径
    if (!to.path.startsWith('/customer') && to.path !== '/') {
      console.log('[路由守卫] 客户端环境访问非客户端路径:', to.path, '环境:', appEnv)
      next('/customer/login')
      return
    }
  }
  // 如果没有环境变量，再根据域名判断
  else if (hostname === 'www.sainanecv.com' || hostname === 'sainanecv.com' ||
          hostname === 'www.xiaobangkeyan.com' || hostname === 'xiaobangkeyan.com') {
    // 如果是www域名或主域名，只能访问客户端路径
    if (!to.path.startsWith('/customer') && to.path !== '/') {
      console.log('[路由守卫] www域名访问非客户端路径:', to.path)
      next('/customer/login')
      return
    }
  }
  else if (hostname === 'admin.sainanecv.com' || hostname === 'admin.xiaobangkeyan.com') {
    if (!to.path.startsWith('/admin') && to.path !== '/') {
      console.log('[路由守卫] 管理员域名访问非管理员路径:', to.path)
      next('/admin/login')
      return
    }
  } else if (hostname === 'merchant.sainanecv.com' || hostname === 'merchant.xiaobangkeyan.com') {
    if (!to.path.startsWith('/merchant') && to.path !== '/') {
      console.log('[路由守卫] 商家域名访问非商家路径:', to.path)
      next('/merchant/login')
      return
    }
  } else if (hostname === 'customer.sainanecv.com' || hostname === 'customer.xiaobangkeyan.com') {
    if (!to.path.startsWith('/customer') && to.path !== '/') {
      console.log('[路由守卫] 客户端域名访问非客户端路径:', to.path, '域名:', hostname)
      next('/customer/login')
      return
    }
  }

  console.log('[路由守卫] 允许继续访问:', to.path)
  next()
})

// 路由守卫，处理页面标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 供应商管理系统'
  } else {
    document.title = '供应商管理系统'
  }
  next()
})

export default router 